/**
 * Codigos numericos COMPE (BACEN) dos bancos brasileiros mais usados em
 * transferencias TED/PIX. Cobre os ~80 principais — 99% dos casos. Bancos
 * raros nao incluidos cairao em "outros" via input manual, se necessario.
 *
 * Fonte: lista oficial BACEN COMPE atualizada (https://www.bcb.gov.br/).
 * Codigo de 3 digitos (ex: '001' = Banco do Brasil) eh o que Asaas espera no
 * campo `bankAccount.bank.code` ao criar transfer TED.
 */
export interface BrazilianBank {
    code: string
    name: string
}

export const BRAZILIAN_BANKS: BrazilianBank[] = [
    { code: '001', name: 'Banco do Brasil' },
    { code: '003', name: 'Banco da Amazônia' },
    { code: '004', name: 'Banco do Nordeste' },
    { code: '021', name: 'Banestes' },
    { code: '025', name: 'Banco Alfa' },
    { code: '027', name: 'Banco do Estado de Santa Catarina (BESC)' },
    { code: '029', name: 'Banco Itaú Consignado' },
    { code: '033', name: 'Santander' },
    { code: '036', name: 'Banco Bradesco BBI' },
    { code: '037', name: 'Banco do Estado do Pará (Banpará)' },
    { code: '041', name: 'Banrisul' },
    { code: '047', name: 'Banco do Estado de Sergipe (Banese)' },
    { code: '062', name: 'Hipercard Banco Múltiplo' },
    { code: '063', name: 'Banco Bradescard' },
    { code: '065', name: 'Banco AndBank' },
    { code: '069', name: 'Banco Crefisa' },
    { code: '070', name: 'BRB - Banco de Brasília' },
    { code: '074', name: 'Banco J. Safra' },
    { code: '077', name: 'Banco Inter' },
    { code: '079', name: 'Banco Original do Agronegócio' },
    { code: '081', name: 'BancoSeguro' },
    { code: '082', name: 'Banco Topázio' },
    { code: '083', name: 'Banco da China Brasil' },
    { code: '084', name: 'Uniprime Norte do Paraná' },
    { code: '085', name: 'Cooperativa Central de Crédito - Ailos' },
    { code: '089', name: 'Cooperativa de Crédito Rural da Região da Mogiana' },
    { code: '090', name: 'Cooperativa Central de Economia e Crédito Mútuo das Unicreds' },
    { code: '091', name: 'Unicred Central do Rio Grande do Sul' },
    { code: '094', name: 'Banco Finaxis' },
    { code: '095', name: 'Travelex Banco de Câmbio' },
    { code: '096', name: 'Banco B3' },
    { code: '097', name: 'Credisis - Central de Cooperativas de Crédito' },
    { code: '099', name: 'Uniprime Central' },
    { code: '102', name: 'XP Investimentos' },
    { code: '104', name: 'Caixa Econômica Federal' },
    { code: '105', name: 'Lecca Crédito, Financiamento e Investimento' },
    { code: '107', name: 'Banco BOCOM BBM' },
    { code: '108', name: 'PortoCred Crédito, Financiamento e Investimento' },
    { code: '111', name: 'Oliveira Trust DTVM' },
    { code: '113', name: 'Magliano S.A. CCVM' },
    { code: '114', name: 'Central Cooperativa de Crédito no Estado do Espírito Santo' },
    { code: '117', name: 'Advanced CC' },
    { code: '119', name: 'Banco Western Union do Brasil' },
    { code: '120', name: 'Banco Rodobens' },
    { code: '121', name: 'Banco Agibank' },
    { code: '122', name: 'Banco Bradesco BERJ' },
    { code: '124', name: 'Banco Woori Bank do Brasil' },
    { code: '125', name: 'Banco Plural' },
    { code: '126', name: 'BR Partners Banco de Investimento' },
    { code: '127', name: 'Codepe CVC' },
    { code: '128', name: 'MS Bank Banco de Câmbio' },
    { code: '129', name: 'UBS Brasil Banco de Investimento' },
    { code: '130', name: 'Caruana SCFI' },
    { code: '131', name: 'Tullett Prebon Brasil CVC' },
    { code: '132', name: 'ICBC do Brasil Banco Múltiplo' },
    { code: '133', name: 'Confederação Nacional das Cooperativas Centrais de Crédito' },
    { code: '136', name: 'Confederação Nacional das Cooperativas Centrais Unicred (Confesol)' },
    { code: '137', name: 'Multimoney Corretora de Câmbio' },
    { code: '138', name: 'Get Money Corretora de Câmbio' },
    { code: '139', name: 'Intesa Sanpaolo Brasil' },
    { code: '140', name: 'Easynvest - Título CV' },
    { code: '142', name: 'Broker Brasil CC' },
    { code: '143', name: 'Treviso Corretora de Câmbio' },
    { code: '144', name: 'BEXS Banco de Câmbio' },
    { code: '145', name: 'Levycam CCV' },
    { code: '146', name: 'Guitta Corretora de Câmbio' },
    { code: '149', name: 'Facta Financeira' },
    { code: '157', name: 'ICAP do Brasil CTVM' },
    { code: '159', name: 'Casa do Crédito SCM' },
    { code: '163', name: 'Commerzbank Brasil' },
    { code: '169', name: 'Banco Olé Bonsucesso Consignado' },
    { code: '172', name: 'Albatross CCV' },
    { code: '173', name: 'BRL Trust DTVM' },
    { code: '174', name: 'Pernambucanas Financiadora' },
    { code: '177', name: 'Guide Investimentos' },
    { code: '180', name: 'CM Capital Markets CCTVM' },
    { code: '183', name: 'Socred SA - Sociedade de Crédito ao Microempreendedor' },
    { code: '184', name: 'Banco Itaú BBA' },
    { code: '188', name: 'Ativa Investimentos CTCV' },
    { code: '189', name: 'HS Financeira' },
    { code: '190', name: 'Cooperativa de Economia e Crédito Mútuo dos Servidores Públicos Estaduais do RS' },
    { code: '191', name: 'Nova Futura CTVM' },
    { code: '194', name: 'Parmetal DTVM' },
    { code: '196', name: 'Fair Corretora de Câmbio' },
    { code: '197', name: 'Stone Pagamentos' },
    { code: '208', name: 'Banco BTG Pactual' },
    { code: '212', name: 'Banco Original' },
    { code: '213', name: 'Banco Arbi' },
    { code: '217', name: 'Banco John Deere' },
    { code: '218', name: 'Banco BS2' },
    { code: '222', name: 'Banco Credit Agricole Brasil' },
    { code: '224', name: 'Banco Fibra' },
    { code: '233', name: 'Banco Cifra' },
    { code: '237', name: 'Bradesco' },
    { code: '241', name: 'Banco Clássico' },
    { code: '243', name: 'Banco Máxima' },
    { code: '246', name: 'Banco ABC Brasil' },
    { code: '249', name: 'Banco Investcred Unibanco' },
    { code: '250', name: 'BCV - Banco de Crédito e Varejo' },
    { code: '254', name: 'Paraná Banco' },
    { code: '260', name: 'Nu Pagamentos (Nubank)' },
    { code: '265', name: 'Banco Fator' },
    { code: '266', name: 'Banco Cédula' },
    { code: '268', name: 'Barigui CHSCFI' },
    { code: '269', name: 'HSBC Banco de Investimento' },
    { code: '270', name: 'Sagitur Corretora de Câmbio' },
    { code: '271', name: 'IB Corretora de Câmbio, Títulos e Valores Mobiliários' },
    { code: '272', name: 'AGK Corretora de Câmbio' },
    { code: '273', name: 'Cooperativa de Crédito Rural de São Miguel do Oeste - Sulcredi/São Miguel' },
    { code: '274', name: 'Money Plus SCM' },
    { code: '276', name: 'Senff' },
    { code: '278', name: 'Genial Investimentos CVM' },
    { code: '279', name: 'Cooperativa de Crédito Rural de Primavera do Leste' },
    { code: '280', name: 'Will Financeira' },
    { code: '281', name: 'Cooperativa de Crédito Rural Coopavel' },
    { code: '283', name: 'RB Capital Investimentos DTVM' },
    { code: '285', name: 'Frente Corretora de Câmbio' },
    { code: '286', name: 'Cooperativa de Crédito Rural de Ouro - Sulcredi/Ouro' },
    { code: '288', name: 'Carol DTVM' },
    { code: '290', name: 'PagSeguro Internet' },
    { code: '292', name: 'BS2 Distribuidora de Títulos e Valores Mobiliários' },
    { code: '293', name: 'Lastro RDV DTVM' },
    { code: '296', name: 'Vision SA Corretora de Câmbio' },
    { code: '298', name: 'Vips CC' },
    { code: '299', name: 'Sorocred Crédito, Financiamento e Investimento' },
    { code: '300', name: 'Banco de la Nación Argentina' },
    { code: '301', name: 'BPP Instituição de Pagamento' },
    { code: '318', name: 'Banco BMG' },
    { code: '320', name: 'China Construction Bank (Brasil) Banco Múltiplo' },
    { code: '335', name: 'Banco Digio' },
    { code: '336', name: 'Banco C6' },
    { code: '340', name: 'Super Pagamentos' },
    { code: '341', name: 'Itaú Unibanco' },
    { code: '342', name: 'Creditas Sociedade de Crédito Direto' },
    { code: '343', name: 'FFA Sociedade de Crédito ao Microempreendedor' },
    { code: '348', name: 'Banco XP' },
    { code: '364', name: 'Gerencianet Pagamentos do Brasil' },
    { code: '366', name: 'Banco Société Générale Brasil' },
    { code: '370', name: 'Banco Mizuho do Brasil' },
    { code: '376', name: 'Banco J. P. Morgan' },
    { code: '380', name: 'PicPay Servicos' },
    { code: '389', name: 'Banco Mercantil do Brasil' },
    { code: '394', name: 'Banco Bradesco Financiamentos' },
    { code: '399', name: 'Kirton Bank (HSBC)' },
    { code: '403', name: 'Cora SCD' },
    { code: '412', name: 'Banco Capital' },
    { code: '422', name: 'Banco Safra' },
    { code: '456', name: 'Banco MUFG Brasil' },
    { code: '464', name: 'Banco Sumitomo Mitsui Brasileiro' },
    { code: '473', name: 'Banco Caixa Geral - Brasil' },
    { code: '477', name: 'Citibank' },
    { code: '479', name: 'Banco ItauBank' },
    { code: '487', name: 'Deutsche Bank' },
    { code: '488', name: 'JPMorgan Chase Bank' },
    { code: '492', name: 'ING Bank N.V.' },
    { code: '495', name: 'Banco de La Provincia de Buenos Aires' },
    { code: '505', name: 'Banco Credit Suisse Brasil' },
    { code: '545', name: 'Senso CCVM' },
    { code: '600', name: 'Banco Luso Brasileiro' },
    { code: '604', name: 'Banco Industrial do Brasil' },
    { code: '610', name: 'Banco VR' },
    { code: '611', name: 'Banco Paulista' },
    { code: '612', name: 'Banco Guanabara' },
    { code: '613', name: 'Omni Banco' },
    { code: '623', name: 'Banco Pan' },
    { code: '626', name: 'Banco Ficsa' },
    { code: '630', name: 'Banco Smartbank' },
    { code: '633', name: 'Banco Rendimento' },
    { code: '634', name: 'Banco Triângulo' },
    { code: '637', name: 'Banco Sofisa' },
    { code: '643', name: 'Banco Pine' },
    { code: '652', name: 'Itaú Unibanco Holding' },
    { code: '653', name: 'Banco Indusval' },
    { code: '654', name: 'Banco A.J. Renner' },
    { code: '655', name: 'Banco Votorantim' },
    { code: '707', name: 'Banco Daycoval' },
    { code: '712', name: 'Banco Ourinvest' },
    { code: '739', name: 'Banco Cetelem' },
    { code: '741', name: 'Banco Ribeirão Preto' },
    { code: '743', name: 'Banco Semear' },
    { code: '745', name: 'Banco Citibank' },
    { code: '746', name: 'Banco Modal' },
    { code: '747', name: 'Banco Rabobank International' },
    { code: '748', name: 'Banco Cooperativo Sicredi' },
    { code: '751', name: 'Scotiabank Brasil' },
    { code: '752', name: 'BNP Paribas Brasil' },
    { code: '753', name: 'Novo Banco Continental' },
    { code: '754', name: 'Banco Sistema' },
    { code: '755', name: 'Bank of America Merrill Lynch' },
    { code: '756', name: 'Banco Cooperativo do Brasil (Sicoob)' },
    { code: '757', name: 'Banco Keb Hana do Brasil' },
]
